import React, { useState } from 'react';
import './labelTooltip.css';

interface LabelTooltipProps {
    children: React.ReactNode;
    tooltip?: string;
    showTooltip?: boolean;
    disabled?: boolean;
    position?: 'top' | 'bottom' | 'left' | 'right';
    onClick?: () => void;
    onTooltipClick?: () => void;
}

const LabelTooltip: React.FC<LabelTooltipProps> = ({
    children,
    tooltip,
    showTooltip = true,
    disabled = false,
    position = 'top',
    onClick,
    onTooltipClick,
}) => {
    const [isHovering, setIsHovering] = useState(false);
    const [isHoveringTooltip, setIsHoveringTooltip] = useState(false);

    // Show tooltip if hovering over either the main container or the tooltip itself
    const shouldShowTooltip = (isHovering || isHoveringTooltip) && showTooltip && tooltip;

    return (
        <div 
            className="labelTooltip-mainContainer"
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            onClick={disabled ? undefined : onClick}
        >   
            {children}

            {shouldShowTooltip && (
                <div 
                    className={`labelTooltip-tooltip labelTooltip-tooltip--${position}`}
                    onMouseEnter={() => setIsHoveringTooltip(true)}
                    onMouseLeave={() => setIsHoveringTooltip(false)}
                    onClick={onTooltipClick}
                >
                    {tooltip}
                </div>
            )}
        </div>
    );
};

export default LabelTooltip;